import {
  Component,
  h,
  State,
  Element,
  Prop,
  Listen,
  Event,
  type EventEmitter
} from '@stencil/core';
import { isMobile } from '../../utils/media';
import { countrySelectorWidgetEventEmitter } from './utils';
import { searchOverflowToggler } from '../../utils/helpers/overflowToggler';
import type { labelProviderInterface } from '../LabelProviderInterface';

@Component({
  tag: 'uiaas-smart-country-selector-banner',
  shadow: true,
  styleUrl: 'uiaas-smart-country-selector-banner.scss',
})
export class SmartCountrySelectorBanner {
  @State() isVisibleBanner: boolean = true;
  @State() isMobile: boolean = isMobile();

  @Prop() readonly labelProvider: labelProviderInterface;
  @Prop() readonly isSrpVariant: boolean = false;
  @Prop() readonly language: string = 'en';
  @Prop() readonly request: boolean = false;
  @Prop() readonly isGuidedSearch: boolean = false;
  @Prop() readonly totalHits: number | undefined;

  @Element() element;

  private countrySelectorWidgetElement = document.createElement(
    'uiaas-smart-country-selector-widget'
  );

  private accessibilityMode = false;

  @Event({
    eventName: 'search:globalDecommissioningSelector',
  })
    SearchGlobalDecommissioningSelectorEmitterSRP: EventEmitter;

  @Event({
    eventName: 'guided:globalDecommissioningSelector',
  })
    SearchGlobalDecommissioningSelectorEmitterGuided: EventEmitter;

  @Listen('uiaas:accessibility', { target: 'window' })
  handleAccessibility(ev) {
      this.accessibilityMode = ev.detail;
  }

  private loadWidgetToDocumentBody() {
      const widgetTitle = this.labelProvider(
        this.isGuidedSearch
          ? 'country-selector-widget-header'
          : 'smart.country.selector.widget.header',
        'Select your Location'
      );

      this.countrySelectorWidgetElement.setAttribute(
        'is-guided-search',
        this.isGuidedSearch.toString()
      );

      this.countrySelectorWidgetElement.setAttribute(
        'total-hits',
        this.totalHits?.toString()
      );

      this.countrySelectorWidgetElement.setAttribute(
        'accessibilityMode',
        this.accessibilityMode.toString()
      );

      this.countrySelectorWidgetElement.setAttribute('content-text', widgetTitle);
      this.countrySelectorWidgetElement.setAttribute('language', this.language);

      if (!document.body.querySelector('uiaas-smart-country-selector-widget'))
        document.body.append(this.countrySelectorWidgetElement);
      searchOverflowToggler(true);
  }

  render() {
      return (
        <div
          class={{
            'smart-country-selector-banner': true,
            'smart-country-selector-banner--disabled': !this.isVisibleBanner,
            'smart-country-selector-banner--srp-variant': this.isSrpVariant,
            'smart-country-selector-banner--guided-search': this.isGuidedSearch,
          }}
        >
          <div>
            <div class="smart-country-selector-banner-content">
              <span class="smart-country-selector-banner-content__icon">
                <se-icon size="large">web_sdk</se-icon>
              </span>
              <div>
                <div class="smart-country-selector-banner-content-header">
                  <p>
                    {this.labelProvider(
                      this.isGuidedSearch
                        ? 'country-selector-banner-header'
                        : 'smart.country.selector.banner.header',
                      'Looking for products, documents or software?'
                    )}
                  </p>
                </div>
                <span>
                  {this.labelProvider(
                    this.isGuidedSearch
                      ? 'country-selector-banner-content'
                      : 'smart.country.selector.banner.content',
                    'Looking for products, documents or software?'
                  )}
                </span>
              </div>
            </div>
            <section class="smart-country-selector-banner__button-section">
              <qds-button
                importance="emphasized"
                size="large"
                class="smart-country-selector-banner__button"
                onClick={() => {
                    this.loadWidgetToDocumentBody();
                    countrySelectorWidgetEventEmitter(
                      this.isGuidedSearch,
                      this.totalHits,
                      this.SearchGlobalDecommissioningSelectorEmitterGuided,
                      this.SearchGlobalDecommissioningSelectorEmitterSRP
                    );
                }}
                text= {this.labelProvider(
                  this.isGuidedSearch
                    ? 'country-selector-banner-cta'
                    : 'smart.country.selector.banner.cta',
                  'Select location'
                )}
              >

              </qds-button>
            </section>
          </div>
        </div>
      );
  }
}
